import React, {Component} from "react"
import styled from "styled-components"
import {FormattedMessage, injectIntl, InjectIntl} from "@irati/utils/lang"
import Button from "@irati/ui/src/Button"
import {ButtonLink} from "@irati/ui/src/Link"
import companyBenefitsService from "@irati/deals/services/companyBenefits"

import {getDomain} from "@irati/utils/links"
import authentication from "@irati/auth"
import {Deal} from "@irati/types"
import {AreYouSurePopUp} from "../../AreYouSurePopUp"
import {handleBenefitChange} from "../CompanyBenefitsList"

const PreviewButton = styled(ButtonLink)`
  margin-right: 15px;
`

const EditButton = styled(ButtonLink)`
  margin-right: 15px;
`

const FlexWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`

interface State {
  load: Promise<any> | null
}

interface Props extends InjectIntl {
  benefit: Deal,
  onChange: handleBenefitChange,
  onBenefitEdit: (benefit: Deal) => any
}

class CompanyBenefitsActions extends Component<Props, State> {
  deletePopup = React.createRef<any>()

  state: State = {
    load: null
  }

  buildUrl = () => {
    const {benefit} = this.props
    return `${getDomain(authentication.userTenant().subdomain)}/perks/info/${benefit.urlSlug}`
  }

  handleArchive = () => {
    const {benefit} = this.props
    const load = companyBenefitsService.archive(benefit.uuid).then(() => this.props.onChange(benefit, "remove"))
    this.setState({load})
    return load
  }

  openArchivePopup = () => {
    if (this.deletePopup.current) {
      this.deletePopup.current.toggle()
    }
  }

  handleEdit = () => {
    this.props.onBenefitEdit(this.props.benefit)
  }

  render() {
    const {load} = this.state
    const {formatMessage} = this.props
    return (
      <FlexWrapper>
        <PreviewButton href={this.buildUrl()} target="_blank" small>
          <FormattedMessage id="admin.components.companyBenefitsActions.previewButton.text" />
        </PreviewButton>
        <EditButton id="settingsCustomBenefitsEdit_button" onClick={this.handleEdit} small>
          <FormattedMessage id="admin.components.companyBenefitsActions.editButton.text" />
        </EditButton>
        <Button id="settingsCustomBenefitsDelete_button" onClick={this.openArchivePopup} load={load} small>
          <FormattedMessage id="admin.components.companyBenefitsActions.archiveButton.text" />
        </Button>
        <AreYouSurePopUp
          ref={this.deletePopup}
          load={load}
          onSubmit={this.handleArchive}
          text={formatMessage({id: "admin.components.companyBenefitsActions.areYouSurePopUp.text"})}
          buttonText={formatMessage({id: "admin.components.companyBenefitsActions.areYouSurePopUp.buttonText"})} />
      </FlexWrapper>
    )
  }
}

export default injectIntl(CompanyBenefitsActions)
